var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnPlayAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.0034,
    r: 24,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.084 14.438C17.0867 13.7198 17.8141 13.2546 18.4531 13.5122L18.5801 13.5737L35.4375 23.2026C36.0702 23.564 36.1071 24.4427 35.5508 24.8647L35.4316 24.9429L18.502 34.4507C17.8756 34.8023 17.112 34.3986 17.0215 33.7153L17.0127 33.5757L17.084 14.438Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 9.12,
    y1: 5.76342,
    x2: 38.4,
    y2: 41.7634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#253C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36E21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlayAudio);
export default __webpack_public_path__ + "static/media/btn_play_audio.83cab5b0deff1580a5a2625846bd3c88.svg";
export { ForwardRef as ReactComponent };